import styled from 'styled-components'

import { COLORS } from 'consts/colors'

export const DragAreaActiveWrapper = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px dashed ${COLORS.primaryDark};
  position: absolute;
  padding: 91px 0;
  text-align: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1000;
`
